import { Component, Input } from '@angular/core';
import isEqual from 'lodash.isequal';
import { ElementStyle, Element } from 'src/app/core/interfaces/element';

@Component({
  selector: 'element-wyswyg',
  template: '',
})
export class ElementComponent implements Element {
  @Input() id?: string;
  @Input() elementOrder?: number;
  data?: any;
  tabId?: string;
  pageNumber?: number;
  stylecss?: ElementStyle;
  rendered?: boolean;
  modified: boolean = false;

  originalData?: any;

  isModified(newOrder?: number, newPageNumber?: number): boolean {
    let comparisonData = { ...this.data };
    delete comparisonData.prefix;
    delete comparisonData.ytVideoId;
    delete comparisonData.uniqueAnswers;

    const orderChanged = newOrder !== undefined && this.elementOrder !== newOrder;

    const pageNumberChanged = newPageNumber !== undefined && this.pageNumber !== newPageNumber;

    // console.log("original", this.originalData);
    // console.log("modified", comparisonData);

    this.modified = (this.id === undefined) ||
      !isEqual(this.originalData, comparisonData) ||
      orderChanged ||
      pageNumberChanged ||
      (this.data.uploadData != null);
    return this.modified;

  }

}
